import React, { useState, useContext } from "react";
import "./style.css";
import Button from "../Button/Button";
import footerLogo from "Assets/footer-logo.svg";
import { user_Status } from "Api/Api";
import { withRouter } from "react-router-dom";
import appstore from "Assets/app-store-logo.png";
import Breadcrumb from "components/BreadCrumbs/BreadCrumbs";
import ContactReportModal from "components/ContactReportModal/ContactReportModal";
import Modal from "react-bootstrap/Modal";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import { local_routes } from "utils/Routes";
import { org_friendly_url } from "Api/Api";
import UserContext from "store/UserContext";

const Footer = (props) => {
  const userContext = useContext(UserContext);
  const [show, setShow] = useState(false);
  let workspace_base_url = "";
  if (org_friendly_url) {
    workspace_base_url = local_routes.workspace + "/" + org_friendly_url;
  }

  // Toggles modal show
  const showModal = () => {
    setShow(true);
  };
  // Toggles modal hide
  const hideModal = () => {
    setShow(false);
  };

  const noUser = () => {
    window.localStorage.setItem("loginOrigin", "pkCreation");
  };

  const switchTheme = (theme) => {
    userContext.setTheme(theme);
  };

  const switchLanguage = (language_abbreviation) => {
    userContext.setLanguage(language_abbreviation);
  };

  let create_pk_button_text = "PK Create";

  let pk_create_local_route = local_routes.pkcreatehome;
  if (user_Status === 1) {
    pk_create_local_route = local_routes.pkcreation;
  }

  return (
    <footer>
      <section className="breadcrumb-bg breadcrumb-top">
        <div className="container">
          <Breadcrumb
            home={props.homeImg}
            homeRef={props.homeImgRef}
            innerSubPage={props.breadcrumbSubPage}
            mainPage={props.breadcrumbMainPage}
            mainRef={props.mainPageLink}
          />
        </div>
      </section>
      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="footer-head">
                <div className="footer-logo">
                  <a href={workspace_base_url || "/"}>
                    <img src={footerLogo} alt="img" className="img-fluid" />
                  </a>
                </div>
                <div className="create-pk">
                  {window.location.pathname.endsWith(local_routes.pkcreation) ||
                  window.location.pathname.endsWith(
                    local_routes.pkcreatehome
                  ) ? null : (
                    <a href={workspace_base_url + pk_create_local_route}>
                      <Button theme="btn-global btn-green">
                        {create_pk_button_text}
                      </Button>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-4 col-lg-3">
              <div className="footer-links">
                <h4>PechaKucha</h4>
                {user_Status !== 1 && (
                  <React.Fragment>
                    <a href={local_routes.register}>
                      <Button OnClickMet={() => noUser()} theme="sign-up-btn">
                        Sign up
                      </Button>
                    </a>
                    <a href={local_routes.login}>Log in</a>
                  </React.Fragment>
                )}
                <Modal
                  size="md"
                  show={show}
                  onHide={hideModal}
                  className="modal-contact-custom"
                >
                  <div>
                    <ContactReportModal modalText="Please use the 'Support' button in the lower right" />
                    <div>
                      <Button theme="contact-button" OnClickMet={hideModal}>
                        x
                      </Button>
                    </div>
                  </div>
                </Modal>
                <p onClick={showModal}>Contact Us</p>
                <a href={local_routes.about}>About</a>
                <a href="/press">Press</a>
                <a target="_blank" rel="noopener" href={local_routes.shop}>
                  Shop
                </a>
                <a href={local_routes.jobs}>Jobs</a>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-lg-3">
              <div className="footer-links">
                <h4>Discover</h4>
                <a href={local_routes.categories}>Categories</a>
                <a href={local_routes.channels}>Channels</a>
                <a href={local_routes.events}>Events</a>
                <a href={local_routes.cities}>Cities</a>
                <a
                  target="_blank"
                  rel="noopener"
                  href={local_routes.waf_contest}
                >
                  WAF Contest
                </a>
                <a href="/channels/inspire-the-world">INSPIRE</a>
              </div>
            </div>
            <div className="col-sm-12 col-md-4 col-lg-3">
              <div className="footer-links">
                <h4>PK Create</h4>
                <a
                  target="_blank"
                  rel="noopener"
                  href={local_routes.hostanevent}
                >
                  Host an Event
                </a>
                {/*
                <a
                  target="_blank"
                  rel="noopener"
                  href={local_routes.forbusiness}
                >
                  For Schools
                </a>
                <a
                  target="_blank"
                  rel="noopener"
                  href={local_routes.forbusiness}
                >
                  For Business
                </a>
                <a target="_blank" rel="noopener" href={local_routes.usecases}>
                  Use Cases
                </a>
                */}
                <a href={local_routes.pricing}>Pricing</a>
                <a
                  target="_blank"
                  rel="noopener"
                  href={local_routes.pkcreate_help}
                >
                  FAQs
                </a>
              </div>
            </div>
            <div className="col-sm-6 col-md-6 col-lg-3">
              <div className="row">
                <div className="ftr-response">
                  <div className="footer-social">
                    <h4>Follow us</h4>
                    <a href="https://www.facebook.com/PechaKuchaGlobal/">
                      <i className="fa fa-facebook-square"></i>
                    </a>
                    <a href="https://twitter.com/PechaKucha">
                      <i className="fa fa-twitter"></i>
                    </a>
                    <a href="https://www.youtube.com/user/PechaKuchaGlobal">
                      <i className="fa fa-youtube-play"></i>
                    </a>
                    <a href="https://www.instagram.com/pechakucha20x20/">
                      <i className="fa fa-instagram"></i>
                    </a>
                    <a href="https://pechakuchaposters.tumblr.com/">
                      <i className="fa fa-tumblr tumblr-circle"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="row appstore">
                <div className="app-response">
                  <div className="col-sm-6 col-md-6 col-lg-6 pad0">
                    <div className="pad-right3">
                      <a href="https://apps.apple.com/us/app/pechakucha-of-the-day/id1205954170">
                        <img
                          src={appstore}
                          alt="img"
                          className="img-fluid appborder"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6 pad0">
                    <div className="pad-left3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-btm">
        <div className="container">
          <div className="row">
            <div className="col-sm-6">
              <div className="copyright">
                &copy; PechaKucha {new Date().getFullYear()}
              </div>
              <div className="terms-links">
                <a href="/termsofuse">Terms of Use</a>
                <a href="/privacypolicy">Privacy Policy</a>
                <a href="/copyrightpolicy">Copyright Policy</a>
              </div>
            </div>
            <div className="col-sm-3">
              <DropdownButton variant="info" sz="sm" title="Theme">
                <Dropdown.Item
                  onClick={() => switchTheme("light")}
                  active={userContext.theme === "light"}
                >
                  Light
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => switchTheme("dark")}
                  active={userContext.theme === "dark"}
                >
                  Dark (Experimental)
                </Dropdown.Item>
              </DropdownButton>
            </div>
            <div className="col-sm-3">
              <DropdownButton variant="info" sz="sm" title="Language">
                <Dropdown.Item
                  onClick={() => switchLanguage("en-US")}
                  active={userContext.language_abbreviation === "en-US"}
                >
                  English
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => switchLanguage("ja-JP")}
                  active={userContext.language_abbreviation === "ja-JP"}
                >
                  Japanese
                </Dropdown.Item>
              </DropdownButton>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default withRouter(Footer);
